module.exports = "/_next/static/images/a6ea1541cf6d275eb9251f8e2c333437-perks-xs-2x.jpg.webp";